import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ComparisonPanel = ({ motors, onRemove, onClear }) => {
  if (motors?.length === 0) return null;

  const formatPrice = (price) => {
    return new Intl.NumberFormat('id-ID', {
      style: 'currency',
      currency: 'IDR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    })?.format(price);
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-card border-t border-border shadow-honda-glow z-40 animate-slide-up">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-primary rounded-lg flex items-center justify-center">
              <Icon name="GitCompare" size={20} color="white" />
            </div>
            <div>
              <h3 className="text-base md:text-lg font-heading font-bold text-foreground">
                Bandingkan Motor ({motors?.length}/3)
              </h3>
              <p className="text-xs text-muted-foreground">
                Pilih hingga 3 motor untuk dibandingkan
              </p>
            </div>
          </div>
          
          <div className="flex items-center space-x-2">
            <Button
              variant="outline"
              size="sm"
              iconName="Trash2"
              iconPosition="left"
              onClick={onClear}
            >
              <span className="hidden md:inline">Hapus Semua</span>
            </Button>
            <Button
              variant="default"
              size="sm"
              iconName="ArrowRight"
              iconPosition="right"
              disabled={motors?.length < 2}
            >
              Bandingkan
            </Button>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {motors?.map((motor) => (
            <div
              key={motor?.id}
              className="bg-muted rounded-lg p-3 flex items-center space-x-3 relative group"
            >
              <button
                onClick={() => onRemove(motor?.id)}
                className="absolute -top-2 -right-2 w-6 h-6 bg-error text-error-foreground rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity shadow-honda-subtle"
                aria-label="Remove from comparison"
              >
                <Icon name="X" size={14} />
              </button>

              <div className="w-16 h-16 rounded-lg overflow-hidden flex-shrink-0 bg-card">
                <Image
                  src={motor?.image}
                  alt={motor?.imageAlt}
                  className="w-full h-full object-cover"
                />
              </div>

              <div className="flex-1 min-w-0">
                <h4 className="text-sm font-heading font-bold text-foreground line-clamp-1">
                  {motor?.name}
                </h4>
                <p className="text-xs text-muted-foreground mb-1">{motor?.category}</p>
                <p className="text-sm font-heading font-bold text-primary">
                  {formatPrice(motor?.price)}
                </p>
              </div>
            </div>
          ))}

          {[...Array(3 - motors?.length)]?.map((_, index) => (
            <div
              key={`empty-${index}`}
              className="bg-muted/50 rounded-lg p-3 border-2 border-dashed border-border flex items-center justify-center min-h-[88px]"
            >
              <div className="text-center">
                <Icon name="Plus" size={24} color="var(--color-muted-foreground)" className="mx-auto mb-1" />
                <p className="text-xs text-muted-foreground">Tambah Motor</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ComparisonPanel;